import { render, staticRenderFns } from "./policyDialog.vue?vue&type=template&id=b5335010&scoped=true&"
import script from "./policyDialog.vue?vue&type=script&lang=js&"
export * from "./policyDialog.vue?vue&type=script&lang=js&"
import style0 from "./policyDialog.vue?vue&type=style&index=0&id=b5335010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5335010",
  null
  
)

export default component.exports